export default __webpack_public_path__ + "static/Entenda0025-b08f965a06c798b7a5086044d39721e8.jpg";